export var ECalcType;
(function (ECalcType) {
    ECalcType["LABEL"] = "label";
})(ECalcType || (ECalcType = {}));
